var y = (u, p, i) => new Promise((l, o) => {
  var s = (n) => {
    try {
      r(i.next(n));
    } catch (d) {
      o(d);
    }
  }, a = (n) => {
    try {
      r(i.throw(n));
    } catch (d) {
      o(d);
    }
  }, r = (n) => n.done ? l(n.value) : Promise.resolve(n.value).then(s, a);
  r((i = i.apply(u, p)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { productionOrderCloseOrder as z, salesEngineeringOrderCloseOrder as B, closeByIds as V } from "../../request/mtdsretail/post.js";
import { defineComponent as k, onMounted as E, openBlock as x, createElementBlock as h, createElementVNode as c, createVNode as f, withCtx as v, createCommentVNode as O, createTextVNode as w, Fragment as j } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as I, unref as m } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { useMessage as A } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import F from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import _ from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import M from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
const R = { ref: "closeFormContainer" }, S = {
  key: 0,
  style: { width: "100%", display: "flex", "justify-content": "center" }
}, T = { style: { padding: "0 40px" } }, b = { style: { width: "100%", display: "flex", "justify-content": "center", "margin-top": "20px" } }, Q = /* @__PURE__ */ k({
  __name: "closeItem",
  props: {
    type: { default: "" },
    orderId: { default: "" },
    show: { default: "close" }
  },
  emits: ["confirm", "cancal"],
  setup(u, { expose: p, emit: i }) {
    const l = I(!1), o = I({
      reason: ""
    }), s = A(), a = u;
    E(() => y(this, null, function* () {
      g();
    }));
    const r = i, n = () => {
      r("cancal");
    }, d = (t) => t ? t.split(",").map((e) => e.trim()) : [], C = () => y(this, null, function* () {
      if (!o.value.reason)
        return s.warning("请先填写订单关闭说明！"), !1;
      l.value = !0;
      const t = d(a.orderId);
      a.type === "retail" ? z({
        orderId: t.length > 0 ? t[0] : "",
        reason: o.value.reason
      }).then(() => {
        s.success("订单关闭成功！"), r("confirm", "success");
      }).catch(() => {
        s.error("订单关闭失败！"), r("confirm", "error");
      }).finally(() => {
        l.value = !1;
      }) : a.type === "EngorderSingle" ? B({
        orderId: t.length > 0 ? t[0] : "",
        reason: o.value.reason
      }).then(() => {
        s.success("订单关闭成功！"), r("confirm", "success");
      }).catch(() => {
        s.error("订单关闭失败！"), r("confirm", "error");
      }).finally(() => {
        l.value = !1;
      }) : a.type === "EngorderBatch" && V({
        orderId: t.length > 0 ? t.join(",") : "",
        reason: o.value.reason
      }).then(() => {
        s.success("订单关闭成功！"), r("confirm", "success");
      }).catch(() => {
        s.error("订单关闭失败！"), r("confirm", "error");
      }).finally(() => {
        l.value = !1;
      });
    }), g = () => {
      o.value = {
        reason: ""
      };
    };
    return p({ init: g }), (t, e) => (x(), h(j, null, [
      c("div", R, null, 512),
      f(m(M), { show: l.value }, {
        default: v(() => [
          a.show === "close" ? (x(), h("div", S, e[1] || (e[1] = [
            c("p", { style: { color: "#f2c468", "font-weight": "bold", "font-size": "20px" } }, "订单关闭确认", -1)
          ]))) : O("", !0),
          c("div", T, [
            e[2] || (e[2] = c("span", { style: { "font-size": "14px" } }, "订单关闭说明：", -1)),
            f(m(F), {
              value: o.value.reason,
              "onUpdate:value": e[0] || (e[0] = (N) => o.value.reason = N),
              placeholder: "请输入订单关闭原因",
              type: "textarea",
              style: { margin: "10px 0" },
              autosize: {
                minRows: 3,
                maxRows: 5
              }
            }, null, 8, ["value"]),
            e[3] || (e[3] = c("span", { style: { color: "red", "font-size": "14px" } }, "*订单关闭不可逆，请确认后提交", -1))
          ]),
          c("div", b, [
            f(m(_), {
              onClick: C,
              type: "primary",
              size: "medium"
            }, {
              default: v(() => e[4] || (e[4] = [
                w("确定", -1)
              ])),
              _: 1,
              __: [4]
            }),
            f(m(_), {
              onClick: n,
              type: "primary",
              size: "medium",
              style: { "margin-left": "60px" }
            }, {
              default: v(() => e[5] || (e[5] = [
                w("取消", -1)
              ])),
              _: 1,
              __: [5]
            })
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ], 64));
  }
});
export {
  Q as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/close-form/closeItem.vue.js
// module id = 1231
// module chunks = 67